import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTABanner() {
  return <section className="py-20 bg-white" data-id="element-1043">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1044">
        <motion.div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-3xl p-10 md:p-16 text-center relative overflow-hidden shadow-xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-1045">
          {/* Decorative background patterns */}
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-white opacity-10 blur-3xl" data-id="element-1046" />
          <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 rounded-full bg-orange-600 opacity-20 blur-3xl" data-id="element-1047" />

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-1048">
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-1049">
              Ready to Find Your Perfect Pro?
            </h2>
            <p className="text-lg md:text-xl text-amber-50 mb-10" data-id="element-1050">
              Join thousands of homeowners who save time and money with
              FindServiceQuotes.
            </p>
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="inline-flex items-center justify-center gap-2 h-14 md:h-16 px-8 bg-white text-orange-600 hover:bg-slate-50 font-bold text-lg rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-amber-500 shadow-sm" data-id="element-1051">
              Get Started — It's Free
              <ArrowRightIcon className="w-5 h-5" data-id="element-1052" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}